import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Growth = function Growth(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.938 4.063c0-.484.391-.875.875-.875h6.125c.483 0 .874.391.874.874V9.75a.875.875 0 01-1.75 0V6.175l-6.38 6.381a.875.875 0 01-1.238-1.237l6.381-6.382H5.813a.875.875 0 01-.875-.875z",
    fill: "currentColor"
  }));
};
export default Growth;